module.exports = __webpack_public_path__ + "img/shop_bg_re.6d49deef.jpg";